import React from "react";

export const Card = ({ children, className = "", as: As = "div", ...rest }) => (
  <As
    className={`fij-card rounded-sm p-4 sm:p-5 ${className}`}
    {...rest}
  >
    {children}
  </As>
);

export const Badge = ({ tone = "neutral", children, className = "" }) => {
  const tones = {
    positive: "bg-fij-green/10 text-fij-green border-fij-green/20",
    negative: "bg-fij-red/10 text-fij-red border-fij-red/20",
    warning: "bg-fij-amber/10 text-fij-amber border-fij-amber/20",
    info: "bg-fij-blue/10 text-fij-blue border-fij-blue/20",
    neutral: "bg-fij-surfaceHover text-fij-textDim border-fij-border",
  };
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-sm text-[10px] sm:text-xs font-mono border uppercase tracking-wide ${tones[tone]} ${className}`}
    >
      {children}
    </span>
  );
};

export const SectionLabel = ({ children, className = "" }) => (
  <div className={`font-mono text-[10px] uppercase tracking-[0.15em] text-fij-textMuted ${className}`}>
    {children}
  </div>
);

export const Stat = ({ label, value, sub, change, positive, dataTestId }) => (
  <div data-testid={dataTestId}>
    <SectionLabel>{label}</SectionLabel>
    <div className="mt-2 fij-mono text-2xl sm:text-3xl text-fij-text leading-none tracking-tight">{value}</div>
    {(sub || change) && (
      <div className="mt-2 flex items-center gap-2 font-mono text-xs">
        {change && (
          <span className={positive ? "text-fij-green" : "text-fij-red"}>{change}</span>
        )}
        {sub && <span className="text-fij-textMuted">{sub}</span>}
      </div>
    )}
  </div>
);

export const Divider = ({ className = "" }) => (
  <div className={`h-px bg-fij-border ${className}`} />
);
